import type { CSSProperties } from 'react';
import type { OwnerEntity } from '@bhops/shared';
import { otherEntityRobotLabel } from './robot-entity';

// 후보 로봇 행의 소유 법인 표시(작은 꼬리표).
//
// 오너 결정 2026-10-21 — 허니컴로보틱스 로봇도 비욘드허니컴 고객사에 배치. 배정·교체 후보에
// 허니컴로보틱스 장부의 로봇이 섞이는데, 배치·배정해도 소유 법인은 바뀌지 않는다(회계 장부 그대로).
// 고르는 사람이 남의 장부 로봇인 줄 알고 고르게, 고를 대상과 법인이 다른 로봇에만 법인 이름을
// 붙인다. 같은 법인 로봇에는 아무것도 그리지 않는다(종전 화면 그대로).
//
// <select> 의 <option> 안에는 요소를 못 넣으므로 그런 자리는 otherEntityRobotLabel 의 글자를
// 괄호로 덧붙인다 — 이 컴포넌트는 버튼·행처럼 요소를 넣을 수 있는 목록에 쓴다.

export function RobotEntityTag({
  robotEntity,
  referenceEntity,
}: {
  /** 후보 로봇의 소유 법인. 응답에 없으면(옛 서버) 아무것도 그리지 않는다. */
  robotEntity: OwnerEntity | null | undefined;
  /** 고를 대상(배치·계약·고객사)의 법인 — 모르면 내 계정의 법인. */
  referenceEntity: OwnerEntity | null | undefined;
}) {
  const label = otherEntityRobotLabel(robotEntity, referenceEntity);
  if (!label) return null;
  return (
    <span
      data-testid="robot-entity-tag"
      title="이 로봇의 소유 법인입니다. 배치하거나 배정해도 바뀌지 않습니다."
      style={tag}
    >
      {label}
    </span>
  );
}

const tag: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0 6px',
  borderRadius: 999,
  fontSize: 10,
  fontWeight: 600,
  lineHeight: '16px',
  background: 'var(--bg-subtle)',
  color: 'var(--fg-muted)',
  border: '1px solid var(--border-default)',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};
